// @ts-ignore
import type { Slot } from '@swisscom/sdx'; // eslint-disable-line -- Workaround to make HTMLSdxHeaderElement available.

( async () => {
	try {
		await customElements.whenDefined( 'sdx-header' );
		const header = document.querySelector< HTMLSdxHeaderElement >( 'sdx-header' );
		const search = header?.querySelector< HTMLSdxInputElement >( '[type=search]' );

		// Redirect to search results on search submit.
		search?.addEventListener( 'sdxsearch', ( event ) => {
			if ( ! event.target.value ) {
				return;
			}

			const searchUrl = new URL( search.dataset.searchBaseUrl as string );
			searchUrl.searchParams.append( 's', event.target.value );

			window.location.href = searchUrl.toString();
		} );

		// Focus the search input when the search slot is displayed.
		header?.addEventListener( 'sdxslotdisplaychange', ( event ) => {
			const { slot, display } = event.detail;

			if ( slot.slot === 'search' && display === 'open' ) {
				search?.doFocus();
			}
		} );
	} catch {}
} )();
